<div class="empty-state">
  <p class="empty-state__title">{{ title }}</p>
  <p class="empty-state__detail" *ngIf="detail">{{ detail }}</p>
  <ng-content></ng-content>
</div>
